
export default function Hero() {
  return (
    <section className="relative h-screen w-full flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <video
          autoPlay
          muted
          loop
          playsInline
          className="w-full h-full object-cover object-center"
        >
          <source
            src="https://video.bailabailamove.com/ito_21.mp4"
            type="video/mp4"
          />
        </video>
        <div className="absolute inset-0 bg-black/40"></div>
      </div>
      
      <div className="relative z-10 px-6 max-w-6xl mx-auto w-full flex flex-col md:items-center md:justify-center md:text-center text-left items-start justify-center pl-[10%] md:pl-6">
        <h1 className="text-[2.5rem] md:text-7xl lg:text-8xl font-extrabold text-white mb-4 md:mb-16 tracking-[-0.02em] leading-[1.1]">
          <span className="md:hidden">運動が、<br />表現に変わる。</span>
          <span className="hidden md:inline">運動が、表現に変わる。</span>
        </h1>
        
        <p className="text-sm md:text-2xl lg:text-3xl text-white font-light mb-1 md:mb-4 leading-relaxed tracking-wider">
          振付のあるダンスフィットネス
        </p>
        <p className="text-base md:text-4xl lg:text-5xl text-white tracking-wider mt-0 md:mt-2">
          <span className="font-bold">BAILA BAILA</span> <span className="font-light opacity-80">MOVE</span>
        </p>
      </div>
      
      <div className="absolute bottom-12 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-3xl text-white/60"></i>
      </div>
    </section>
  );
}
